import OtherTeamsSection from './OtherTeamsSection';

export default OtherTeamsSection;
